import React from 'react';
import useGetLikedPosts from '../../../../services/hookService/my-account/getLikedPosts/useGetLikedPosts';
import DotsLoading from '../../../../components/dotsLoading';
import MySaleCard from '../card';

const AdsFavour = () => {
  const {data, isLoading} = useGetLikedPosts();

  return (
    <>
      {isLoading ? (
        <div className="d-flex w-100 justify-content-center pt-2">
          <DotsLoading />
        </div>
      ) : (
        <>
          {data?.length === 0 && (
            <p className="flex w-full text-center text-sm font-Medium justify-center py-4 text-gray-800">
              داده ای برای نمایش وجود ندارد!
            </p>
          )}

          {data?.map(item => (
            <MySaleCard data={item} key={item.guid} />
          ))}
        </>
      )}
    </>
  );
};

export default AdsFavour;
